<template>
  <el-table-column
    prop="categories"
    sortable
    label="Csoport(ok)"
    min-width="200"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tooltip v-if="scope.row.categories.length > 1" placement="top" style="max-width: 300px;" popper-class="permission-info-tooltip">
        <div slot="content">
          {{ scope.row.categories.map(c => c.name).join(', ') }}
        </div>
        <el-tag size="small">{{ scope.row.categories.length }} csoport</el-tag>
      </el-tooltip>

      <el-tag v-if="scope.row.categories.length === 1" size="small">{{ scope.row.categories[0].name }}</el-tag>
      <el-tag v-if="scope.row.categories.length === 0" type="danger" size="small">Nincs csoport</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'categories',
  };
</script>
